import {
  selectLoading,
  selectOrder,
} from "containers/CartPage/slice/selectors";
import { useDispatch, useSelector } from "react-redux";
import { IPaymentMethodEnum, IWarehouseListOut } from "openapi/types";
import { Text } from "atoms";
import { TableWrapper } from "./atoms/TableWrapper";
import { CartWrapper } from "./atoms/CartWrapper";
import { SummaryWrapper } from "./atoms/SummaryWrapper";
import LoadingSpinner from "components/LoadingSpinner";
import { executeOrder } from "containers/CartPage/slice";
import { selectWarehouseList } from "containers/ProductsPage/slice/selectors";
import { useEffect, useState } from "react";
import { getTotalPriceOfProducts } from "utils/UtilFunctions";
import { OrderProductsTable } from "../../../../components/OrderProductsTable/OrderProductsTable";
import { useNavigate } from "react-router-dom";
import { selectUserStore } from "containers/App/slice/selectors";
import { ConfirmationDialogue } from "components/ConfirmationDialogue/ConfirmationDialogue";
import { Button, Divider, useTheme } from "@mui/material";

export const CartTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const order = useSelector(selectOrder);
  const loading = useSelector(selectLoading);
  const warehouseList = useSelector(selectWarehouseList);
  const currentStore = useSelector(selectUserStore);
  const [confirmVisibility, setConfirmVisibility] = useState(false);
  const [foundWarehouses, setFoundWarehouses] = useState<IWarehouseListOut[]>(
    [],
  );
  const { palette } = useTheme();

  useEffect(() => {
    const list: IWarehouseListOut[] = [];
    warehouseList.map((warehouse) => {
      if (warehouse.warehouseId) {
        const products = order?.products?.filter((prod) => {
          if (prod.product?.warehouse === warehouse.warehouseId) return true;
          return false;
        });
        if (products && products.length > 0) {
          list.push(warehouse);
        }
      }
    });
    setFoundWarehouses(list);
  }, [warehouseList, order]);

  const handleExecution = () => {
    if (
      order &&
      order.orderId &&
      order.products &&
      order.products?.length > 0
    ) {
      dispatch(
        executeOrder({
          orderId: order?.orderId,
          successMessage: "Comanda a fost trimisă cu succes!",
          navigate,
        }),
      );
    }
  };

  const handleButtonClick = () => {
    if (order?.products?.length && order?.products?.length > 0) {
      if (currentStore?.paymentMethod !== IPaymentMethodEnum.BANK_TRANSFER) {
        setConfirmVisibility(true);
      } else {
        handleExecution();
      }
    }
  };

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <LoadingSpinner />
        </div>
      ) : (
        <TableWrapper>
          <CartWrapper>
            <div
              className="d-flex flex-row justify-content-between align-items-center"
              style={{
                borderBottom: `1px solid ${palette.grey[300]}`,
                paddingBottom: "1rem",
              }}
            >
              <Text bold fontSize="30px" color={palette.primary.main}>
                Cos cumparaturi
              </Text>
              <Text bold fontSize="14px" color={palette.text.primary}>
                {order ? (
                  <>
                    {order?.products && order?.products?.length === 1
                      ? `${order?.products?.length} produs`
                      : `${order?.products?.length} produse`}
                  </>
                ) : (
                  "0 produse"
                )}
              </Text>
            </div>
            {order?.products && order.products.length > 0 ? (
              <OrderProductsTable
                warehouseList={foundWarehouses}
                order={order}
                disabled={false}
              />
            ) : (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "80%" }}
              >
                <Text fontSize="18px" bold color={palette.grey[600]}>
                  Cosul este gol. Adaugati produse
                </Text>
              </div>
            )}
          </CartWrapper>
          <Divider orientation="vertical" flexItem />
          <SummaryWrapper>
            <div>
              <Text
                style={{ marginBottom: "1rem" }}
                bold
                fontSize="30px"
                color="black"
              >
                Sumar
              </Text>
              {foundWarehouses.map((warehouse) => (
                <div style={{ marginBottom: "0.5rem" }}>
                  <Text color={palette.secondary.dark} bold fontSize="18px">
                    {warehouse.title}
                  </Text>
                  <Text
                    color="black"
                    fontSize="18px"
                  >{`Pret: ${getTotalPriceOfProducts(
                    order?.products ?? [],
                    warehouse.warehouseId,
                  )} RON`}</Text>
                </div>
              ))}
            </div>
            <div>
              <Text
                fontSize="26px"
                color="black"
              >{`Pret total: ${getTotalPriceOfProducts(
                order?.products ?? [],
              )} RON`}</Text>
              <Button
                variant="contained"
                onClick={handleButtonClick}
                style={{ height: "40px", marginTop: "0.5rem", width: "100%" }}
              >
                Trimite comanda
              </Button>
            </div>
          </SummaryWrapper>
          {confirmVisibility && (
            <ConfirmationDialogue
              onClose={() => setConfirmVisibility(false)}
              description="Acest pop-up este un placeholder pentru plată cu card, apasă 'Confirmă' pentru a trimite comanda"
              onConfirm={handleExecution}
            />
          )}
        </TableWrapper>
      )}
    </>
  );
};
